import React, { useCallback } from 'react';

import { Pencil } from 'lucide-react';
import type { SingleValue } from 'react-select';

import { Select } from '@/_components';
import { snackbar, useCopyToClipboard } from '@/_shared';

import { ActionButton } from '../../../actions/action-button';
import { ActionButtonContainer } from '../../../layout';
import type { EmailQuerySchema, EmailsProps } from '../shared';

const EmailsPreviewBase = ({ value, onOpen, isEditable }: Omit<EmailsProps, 'onChange'> & { onOpen: () => void }) => {
  const { copy } = useCopyToClipboard();

  const handleOnChange = useCallback(
    (e: SingleValue<EmailQuerySchema>) => {
      copy(e?.email || '');
      snackbar.success(`${e?.email || ''} has been copied to clipboard`);
    },
    [copy]
  );

  return (
    <section className="flex flex-nowrap">
      <Select
        label="Emails"
        onChange={handleOnChange}
        value={value?.[0]}
        options={value}
        getOptionLabel={(items) => items.email}
        singleValueClassName="lowercase!"
        isClearable={false}
        labelProps={{ className: isEditable ? 'w-[calc(100%_+_1.75rem)]' : '' }}
        menuClassName={isEditable ? 'w-[calc(100%+1.75rem)]!' : ''}
      />
      {isEditable && (
        <ActionButtonContainer>
          <ActionButton title="Edit Emails" disabled={!value} icon={Pencil} onClick={onOpen} />
        </ActionButtonContainer>
      )}
    </section>
  );
};

export const PreviewEmails = React.memo(EmailsPreviewBase);
